import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

/** Shared wizard navigation button / toast labels for all case-request flows. */
export function useWizardNavLabels() {
  const { t } = useTranslation();
  return useMemo(
    () => ({
      cancel: t('common.cancel'),
      back: t('wizard.nav.back'),
      next: t('wizard.nav.next'),
      saveAsDraft: t('wizard.nav.saveAsDraft'),
      saving: t('common.saving'),
      reviewBeforeSubmission: t('wizard.nav.reviewBeforeSubmissionBtn'),
      submitRequest: t('wizard.nav.submitRequest'),
      submitting: t('wizard.nav.submitting'),
      cancelCaseRequest: t('wizard.nav.cancelCaseRequest'),
      cancelConfirm: t('wizard.nav.cancelConfirm'),
      draftSaved: t('wizard.nav.draftSaved'),
      draftSaveFailed: t('wizard.nav.draftSaveFailed'),
      fillRequiredFields: t('wizard.nav.fillRequiredFields'),
    }),
    [t],
  );
}
